import { useGLTF } from '@react-three/drei';

function Koin() {
  const { nodes, materials } = useGLTF('/models/Koin.gltf');
  return (
    <group dispose={null}>
      <mesh geometry={nodes.Cilindro.geometry} material={materials['Material.001']} rotation={[0, 0, -1.61]} scale={[1, 0.3, 1]} />
      <mesh geometry={nodes.ICON.geometry} material={materials['Material.002']} position={[0.36, 0.25, -0.14]} rotation={[0, 0, -1.61]} />
    </group>
  );
}

useGLTF.preload('/models/Koin.gltf');

export default Koin;
